import {
  Component,
  inject,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';

import { Permission } from 'src/app/shared/constants/permissions';
import { ChartsService } from '../../services/bar-charts-service';
import { DownloadChartsPdfService } from '../../services/download-charts-pdf.service';

@Component({
  selector: 'app-ticket-insights',
  templateUrl: './ticket-insights.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    DownloadChartsPdfService,
    ChartsService,
    ...ChartsService.providers,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TicketInsightsComponent {
  readonly Permission = Permission;

  private readonly router$ = inject(Router);

  private readonly downloadChartsPdfService$ = inject(DownloadChartsPdfService);

  readonly charts$ = inject(ChartsService);

  readonly loading: boolean = false;

  readonly isDownloading = this.downloadChartsPdfService$.isDownloading;

  downloadFilesAsPdf(): void {
    if (!this.isDownloading()) {
      this.downloadChartsPdfService$.downloadCharts(this.charts$);
    }
  }

  handleNavigation(link: string): void {
    this.router$.navigate([link]);
  }

  getThresholdColor(
    thresholds: Record<number, { color: string }>,
    value: number,
  ): string {
    const keys = Object.keys(thresholds)
      .map(Number)
      .sort((a, b) => a - b);
    let color = '#000';
    for (const key of keys) {
      if (value >= key) color = thresholds[key].color;
    }
    return color;
  }
}
